import React, { useCallback, useEffect, useState } from 'react';
import { ConfirmationDialog } from './confirmation-dialog';
import { getSnapshot, resolveConfirmation, subscribe } from './confirmation-store';
import type { ConfirmationRequest } from './types';

export function ConfirmationProvider({ children }: { children: React.ReactNode }) {
  const [request, setRequest] = useState<ConfirmationRequest | null>(getSnapshot);

  useEffect(() => {
    return subscribe(setRequest);
  }, []);

  const handleClose = useCallback(() => {
    resolveConfirmation(false);
  }, []);

  const handleAction = useCallback((label: string) => {
    resolveConfirmation(label);
  }, []);

  return (
    <>
      {children}
      {request !== null && (
        <ConfirmationDialog
          visible
          onClose={handleClose}
          variant={request.variant}
          icon={request.icon}
          title={request.title}
          description={request.description}
          cancelLabel={request.cancelLabel}
          actions={request.actions.map((action) => ({
            ...action,
            onPress: () => handleAction(action.label),
          }))}
          testID="confirmation-dialog"
        >
          {request.children}
        </ConfirmationDialog>
      )}
    </>
  );
}
